import { Loader2 } from 'lucide-react';

export function ScreenLoading({ text }: { text: string }) {
  return (
    <div className="w-full max-w-[400px] text-center mt-12">
      <div className="flex flex-col items-center gap-5">
        <Loader2 className="h-10 w-10 animate-spin text-brand-700" />
        <p className="text-[15px] text-gray-500 leading-relaxed">{text}</p>
      </div>
    </div>
  );
}
